import { fixedUiTpl } from '@/i18n/fixedUi';

/**
 * SHEIN query-category-tree 响应解析
 */

export function normalizeCategoryTree(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  return [];
}

export function getCategoryRoots(raw) {
  return normalizeCategoryTree(raw);
}

export function isLeafCategoryNode(node) {
  if (!node || typeof node !== 'object') return false;
  if (node.last_category === true) return true;
  const children = node.children;
  return !Array.isArray(children) || children.length === 0;
}

export function findCategoryNodeByPath(roots, pathIds) {
  const path = [];
  let nodes = roots;
  for (const id of pathIds) {
    const node = nodes.find((item) => String(item.category_id) === String(id));
    if (!node) break;
    path.push(node);
    nodes = Array.isArray(node.children) ? node.children : [];
  }
  return path;
}

/** 按末级（或任意节点）类目 ID 反查从根到该节点的 pathIds */
export function findCategoryPathIds(raw, categoryId) {
  const target = String(categoryId ?? '').trim();
  if (!target) return [];
  const roots = getCategoryRoots(raw);

  const walk = (nodes, ancestors) => {
    if (!Array.isArray(nodes)) return null;
    for (const node of nodes) {
      if (!node || typeof node !== 'object') continue;
      const id = String(node.category_id ?? '');
      const next = [...ancestors, id];
      if (id && id === target) return next;
      const found = walk(node.children, next);
      if (found) return found;
    }
    return null;
  };

  return walk(roots, []) || [];
}

export function buildCategoryColumns(roots, pathIds) {
  const columns = [];
  let nodes = roots;
  if (nodes.length > 0) {
    columns.push(nodes);
  }
  for (const id of pathIds) {
    const node = nodes.find((item) => String(item.category_id) === String(id));
    if (!node) break;
    const children = Array.isArray(node.children) ? node.children : [];
    if (children.length > 0) {
      columns.push(children);
      nodes = children;
    } else {
      break;
    }
  }
  return columns;
}

/** 扁平化末级类目，供发品页下拉选择 */
export function flattenLeafCategories(raw) {
  const roots = getCategoryRoots(raw);
  const leaves = [];

  const walk = (nodes, ancestors) => {
    if (!Array.isArray(nodes)) return;
    for (const node of nodes) {
      if (!node || typeof node !== 'object') continue;
      const path = [...ancestors, node];
      if (isLeafCategoryNode(node)) {
        const label = path.map((n) => n.category_name).filter(Boolean).join(' / ');
        leaves.push({
          categoryId: node.category_id != null ? String(node.category_id) : '',
          productTypeId: node.product_type_id != null ? String(node.product_type_id) : '',
          label: label || fixedUiTpl('分类 {0}', node.category_id ?? ''),
        });
      } else {
        walk(node.children, path);
      }
    }
  };

  walk(roots, []);
  return leaves;
}
